export const DIALOG_MAX_HEIGHT = "70vh";
